import { Heading } from '@/components/Typography/Heading'
import { cn } from '@/lib'

export const FormSection = ({
	title,
	children,
}: {
	title: React.ReactNode
	children: React.ReactNode
}) => (
	<>
		<div className="flex items-center gap-5 mb-3">
			<Heading color="caption" level="5">
				{title}
			</Heading>
			<div className="h-[1px] grow" />
		</div>
		{children}
	</>
)

export const FormRow = ({
	className,
	...props
}: React.HTMLProps<HTMLDivElement>) => (
	<div className={cn('flex flex-wrap gap-x-3 mb-4', className)} {...props} />
)

export const FormInput = ({
	className,
	...props
}: React.HTMLProps<HTMLDivElement>) => <div className={className} {...props} />
